export default "__VITE_ASSET__CFfVZM_p__"